export const projectInfo = {
  'smart-store': {
    title: 'SmartStore',
    subtitle: 'Local Business Digital Platform',
    status: { phase: 'Development', currentStep: 3 },
    overview: 'A scalable platform for local vendors to list and manage shops, products, services, and orders through a mobile application.',
    color: '#1dbc01',
    colortik: 'rgb(37, 37, 37)',
    sections: [
      {
        heading: 'Core Capabilities',
        items: [
          'Vendor registration and multi-shop management',
          'Product and service listing with pricing and offers',
          'Order and employee management',
          'Advertisement and banner promotion',
          'Customer browsing by location and category'
        ]
      },
      {
        heading: 'Backend & Engineering',
        items: [
          'Built with Spring Boot & RESTful APIs',
          'Database integration (MongoDB / SQL)',
          'Structured Entity–Repository–Service architecture',
          'Designed to handle up to 10,000 users',
          'Role-based operations (Vendor, User, Admin)'
        ]
      }
    ],
    outcome: 'Digital enablement for local businesses with a centralized, scalable, and maintainable backend system.'
  },
  'miss-kla': {
    title: 'MissKla',
    subtitle: 'Traditional Gift Packaging & Event Styling',
    status: { phase: 'Design', currentStep: 2 },
    overview: 'A premium digital platform showcasing specialized traditional Indian gift packaging for weddings and events.',
    color: '#1dbc01',
    colortik: 'rgb(37, 37, 37)',
    sections: [
      {
        heading: 'Cultural Gift Services',
        items: [
          'Custom Wedding Trousseau packaging',
          'Traditional Shagun hampers',
          'Themed gift wrapping',
          'Eco-friendly hand-crafted designs'
        ]
      }
    ],
    outcome: 'Elevated the gifting experience by providing a digital gateway to traditional Indian art.'
  }
};